import { range } from '../../../utils/range';

export type PagerEntry = number | '…';

// Which page links the pager shows (0091): always the first and the last page,
// the current one and two either side of it, '…' for a gap. A gap of exactly
// one page shows that page instead — an ellipsis hiding one number saves
// nothing. Up to 7 pages show every number
export function pagerPages(page: number, pageCount: number): PagerEntry[] {
  if (pageCount <= 7) {
    return [...range(pageCount, 1)];
  }

  const shown = new Set([1, pageCount]);

  for (const p of range(5, page - 2)) {
    if (p >= 1 && p <= pageCount) {
      shown.add(p);
    }
  }

  const pages = [...shown].sort((a, b) => a - b);
  const entries: PagerEntry[] = [];

  pages.forEach((p, index) => {
    const previous = pages[index - 1];

    if (previous !== undefined && p - previous === 2) {
      entries.push(previous + 1);
    } else if (previous !== undefined && p - previous > 2) {
      entries.push('…');
    }

    entries.push(p);
  });

  return entries;
}
